import styles from "./generator.module.scss";
import Product from "./product"; // Standard import

export default function ProductList({ shuffledProducts }) {
  return (
    <div className={styles.productList}>
      {shuffledProducts.map((data, i) => (
        <Product data={data} key={i} />
      ))}
    </div>
  );
}
